import ruvixxLogo from "assets/ruvixx-icon-orange.svg";

export function AppLogo() {
  return (
    <img src={ruvixxLogo} alt="Ruvixx" className="tw:size-8 tw:shrink-0" />
  );
}
